import Model, { valueWithArray } from 'ducker-model';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import dayjs from 'dayjs';

function formatDate(time) {
  return dayjs(time).isValid() && !isEmpty(time) ? dayjs(time).format('YYYY-MM-DD') : '';
}

const property = {
  indexName: String,
  stageRiseListIndexInfo: valueWithArray(Object),
};

const replacedKeyFromPropertyName = {
  indexName: {
    property: ['data', 'mergeData.benchMark'],
    computed: ([indexDiyInfo, benchmark]) => {
      const info = (indexDiyInfo || []).find((item) => item.INDEXCODE === benchmark);
      return info?.INDEXNAME ?? '';
    },
  },

  stageRiseListIndexInfo: {
    property: ['data', 'mergeData.nSmallType', 'mergeData.benchMark'],
    computed: ([indexDiyInfo, nSmallType, benchMark]) => {
      function handleIndexInfo(info) {
        const allInfo = (info || []).find((item) => item.INDEXCODE === `DCGD${nSmallType}9`) || {};
        const canBuyInfo = (info || []).find((item) => item.INDEXCODE === `DCGD${nSmallType}10`) || {};
        const indexInfo = (info || []).find((item) => item.INDEXCODE === benchMark) || {};
        const temp = ['W', 'M', 'Q', 'HY', 'Y', 'TWY', 'TRY', 'FY', 'SE', 'SY'].map((key) => ({
          valueCanBuy: isEmpty(canBuyInfo[key]) ? '--' : parseFloat(canBuyInfo[key]).toFixed(2),
          value: isEmpty(allInfo[key]) ? '--' : parseFloat(allInfo[key]).toFixed(2),
          indexValue: isEmpty(indexInfo[key]) ? '--' : parseFloat(indexInfo[key]).toFixed(2),
          stageKey: key,
          updateDate: formatDate(allInfo?.EUTIME),
          updateDateCanBuy: formatDate(canBuyInfo?.EUTIME),
        }));
        return temp;
      }
      return handleIndexInfo(indexDiyInfo);
    },
  },
};

export default new Model(property, replacedKeyFromPropertyName);
